export const NORMAL_TICKET = "0"
export const VIP_TICKET = "1"